import React,{Component} from 'react';
import ScoreWheel from '../takeQuiz/ScoreWheel'
import Collapsible from 'react-collapsible';

//Show Tabs with Progress bar instead of score wheel on Mobile
export default class MobileScoreWheel extends Component {

    

    constructor(props){
      super(props);
      
      this.state = {
        activeIndex :  props.categoryForWheel.indexOf(props.randomCategory)
      }
    }

    static getDerivedStateFromProps(props) {
      console.log(' props.categoryForWheel.indexOf(props.randomCategory)', props.categoryForWheel.indexOf(props.randomCategory));
      
      return  {
          activeIndex :  props.categoryForWheel.indexOf(props.randomCategory)
      }
    }


      
    onTabChange = (newActiveTabIndex) => {
      this.setState({
        activeIndex:newActiveTabIndex
      })
    }
    render(){
      let activeIndex = this.props.categoryForWheel.indexOf(this.props.randomCategory)
      if(activeIndex < 0)
        return <div></div>
      return  <div> 
             
              {this.props.categoryForWheel.map((categorySetId,catIdIndex) =>
                      <Collapsible  trigger={this.props.categoriesMap[categorySetId].categoryName} key={"Tab"+catIdIndex} open={activeIndex === catIdIndex}>
                        
                          {console.log("this.state.categoriesMap",this.props.categoriesMap[categorySetId])}
                          <ScoreWheel 
                          key={catIdIndex}
                          score={Math.round((this.props.categoriesMap[categorySetId].score /
                            ((this.props.categoryMasteryCount[categorySetId] !== undefined && 
                              this.props.categoryMasteryCount[categorySetId] !==null && 
                              this.props.categoryMasteryCount[categorySetId] !== 0) 
                              ?
                                this.props.categoryMasteryCount[categorySetId] 
                              : this.props.masteryCount))*100) }
                          title={this.props.categoriesMap[categorySetId].categoryName}
                          colorOne="blue"
                          colorTwo="green"
                          colorThree="darkgreen"  ></ScoreWheel>
                        
                        </Collapsible >)}
              
              </div>

    }
     
   
}